import { render } from "./deleteFang.vue?vue&type=template&id=327d6006&scoped=true"
import script from "./deleteFang.vue?vue&type=script&lang=js"
export * from "./deleteFang.vue?vue&type=script&lang=js"

import "./deleteFang.vue?vue&type=style&index=0&id=327d6006&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-327d6006"

export default script